exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/common/mat-chip-list/mat-chip-list.component.scss
// module id = ../../../../../src/app/main/content/apps/common/mat-chip-list/mat-chip-list.component.scss
// module chunks = main